import { BsFillPersonVcardFill } from 'react-icons/bs';
import { PiSimCard } from 'react-icons/pi';
import { FaUser } from 'react-icons/fa';
import { BsDeviceSsd } from "react-icons/bs";

export const iconsAppData = {
  samIcon: <PiSimCard />,
  cardIcon: <BsFillPersonVcardFill />,
  userIcon: <FaUser />,
  deviceIcon: <BsDeviceSsd />
  // Add more icons as needed
} as { [key: string]: JSX.Element };
